import { DepositFundsContent } from '../../components/popover/content/DepositFundsContent'
import { MainLayout } from '../../components/layout/MainLayout'

export function DepositFundsPage() {
  return (
    <MainLayout
      redirectOnSelect={false}
      hideBack={false}
      contentClassName="mt-0"
      className="h-screen min-h-auto mb-12"
      heightClassName="h-full"
    >
      <DepositFundsContent className="p-0 pb-[64px]" />
    </MainLayout>
  )
}
